<template>
  <div style="width: 10rem; overflow: hidden;"
    class="animate__animated animate__fadein animate__delay-0.5s animate__slower">
    <navStudent></navStudent>
    <Banner></Banner>
  </div>
</template>

<script>
import navStudent from '../layout/nav-student.vue';
export default {
  components: {
    navStudent
  },
  data() {
    return {
      identity: ''
    }
  },
  created() {

    this.$http.post('/Api/User/isParent/' + localStorage.getItem('uid'), {}, {
      headers: {
        'Authorization': localStorage.getItem('Authorization')
      }
    }).then(res => {
      console.log(res);
    })
    this.$http.post('/Api/Parent/Clause', {}, {
      headers: {
        'Authorization': localStorage.getItem('Authorization')
      }
    }).then(res => {
      console.log(res);
    })
    if (localStorage.getItem('isPhone') == 'null') {
      this.$router.push('/personstudent/phone')
      console.log(123456);
      this.$message({
        message: '请先绑定手机号',
        type: 'warning'
      });
    }
  }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/pages/index-student.vue